import axios from "axios";

export const state = {
    pharmacy_stock: [],
    sale_cart: [],
    sales_report: [],
    pay_modes: [],
    total_cart: "",
    sale_detail: "",
    all_debtors: [],
    add_state: false,
    save_state: false,
    saleId: "",
    visit_incomplete_dosage_items: []
};

export const getters = {
    VisitIncompleteDosageItems: state => state.visit_incomplete_dosage_items.data,
    PharmacyStock: state => state.pharmacy_stock.data,
    SaleCart: state => state.sale_cart.data,
    TotalCart: state => state.total_cart,
    GetDebtors: state => state.all_debtors.data,
    PaymentModes: state => state.pay_modes,
    AddState: state => state.add_state,
    SaveState: state => state.save_state,
    SalesReport: state => state.sales_report.data,
    SalesId: state => state.saleId,
    SaleDetail: state => state.sale_detail.data,
};

export const mutations = {
    SET_PHARMACY_ITEMS(state, newValue) {
        state.pharmacy_stock = newValue
    },
    SET_ADD_STATE(state, newValue) {
        state.add_state = newValue
    },
    SET_SAVE_STATE(state, newValue) {
        state.save_state = newValue
    },
    SET_SALE_ID(state, newValue) {
        state.saleId = newValue
    },
    SET_SALE_CART(state, newValue) {
        state.sale_cart = newValue
    },
    SET_TOTAL_CART(state, newValue) {
        state.total_cart = newValue
    },
    SET_PAY_MODE(state, newValue) {
        state.pay_modes = newValue
    },
    SET_SALES_REPORT(state, newValue) {
        state.sales_report = newValue
    },
    SET_DEBTORS(state, newValue) {
        state.all_debtors = newValue
    },
    SET_INCOMPLETE_Dosage_ITEMS(state, newValue) {
        state.visit_incomplete_dosage_items = newValue
    },
    SET_SALE_DETAIL(state, newValue) {
        state.sale_detail = newValue
    },
};

export const actions = {
    fetchVisitIncompleteDosageItem({ commit }, id) {
        axios.get(`visitincompletedosageitems/${id}`).then(res => {
            commit('SET_INCOMPLETE_Dosage_ITEMS', res.data)
        })
    },
    fetchPharmacyItems({ commit }) {
        axios.get('fetch_items').then(pi_res => {
            commit('SET_PHARMACY_ITEMS', pi_res.data)
        })
    },
    payDebt({ dispatch, commit }, data) {
        commit('SET_SAVE_STATE', true)
        axios.post('pay_debt', data).then(response => {
            commit('SET_SAVE_STATE', false)
            dispatch('fetchDebtors')
            if (response.status == 200) {
                let message = { 'msg': "Debt Cleared successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to clear debt" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATE', false)
            let message = { 'msg': "Failed to clear debt" }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchDebtors({ commit }) {
        axios.get('fetch_debtors').then(res => {
            commit('SET_DEBTORS', res.data)
        })
    },
    fetchSalesReport({ commit }) {
        axios.get('sales').then(pi_res => {
            commit('SET_SALES_REPORT', pi_res.data)
        })
    },
    fetchCart({ commit }) {
        axios.get('newsale').then(cart => {
            commit('SET_SALE_CART', cart.data)
        })
    },
    fetchTotCart({ commit }) {
        axios.get('fetch_totals').then(total => {
            commit('SET_TOTAL_CART', total.data)
        })
    },
    fetchVisitCart({ commit }) {
        axios.get('newsale').then(cart => {
            commit('SET_SALE_CART', cart.data)
        })
    },
    fetchVisitTotCart({ commit }) {
        axios.get('fetch_totals').then(total => {
            commit('SET_TOTAL_CART', total.data)
        })
    },

    addToCart({ dispatch, commit }, data) {
        commit('SET_ADD_STATE', true)
        axios.post('newsale', data).then(response => {
            commit('SET_ADD_STATE', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status == 200) {
                let message = { 'msg': "Item added successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to add item" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_DISPENSE_STATE', false)
            let message = { 'msg': "Failed to add item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editCart({ dispatch, commit }, data) {
        commit('SET_ADD_STATE', true)
        axios.put(`newsale/${data.id}`, data).then(response => {
            commit('SET_ADD_STATE', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status == 200) {
                let message = { 'msg': "Item edited successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to edit item" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_DISPENSE_STATE', false)
            let message = { 'msg': "Failed to edit item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteCart({ dispatch, commit }, data) {
        commit('SET_ADD_STATE', true)
        axios.delete(`newsale/${data.id}`).then(response => {
            commit('SET_ADD_STATE', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status == 200) {
                let message = { 'msg': "Item deleted successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to delete item" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_DISPENSE_STATE', false)
            let message = { 'msg': data.name + ' adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    saveSale({ dispatch, commit }, data) {
        commit('SET_SAVE_STATE', true)
        axios.post(`save_sale`, data).then(response => {
            commit('SET_SAVE_STATE', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status == 200) {
                commit('SET_SALE_ID', response.data.id)
                let message = { 'msg': "Sale Recorded successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to record Sale" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_DISPENSE_STATE', false)
            let message = { 'msg': "Failed to record Sale" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchSalesDetail({ commit }, id) {
        axios.get(`sales/${id}`).then(sale => {
            commit('SET_SALE_DETAIL', sale.data)
        })
    },
};